import React from 'react'
import { useLocation } from 'react-router-dom';

function NavBar() {

    const location = useLocation();
    const isTandCPage = location.pathname === '/terms';
    const isPandPPage = location.pathname === '/privacy';

  return (
    <div className="sticky-navbar">
       <nav className="navbar navbar-expand-lg shadow-lg">
            <div className="container">
                <a className="navbar-brand" href="index.html">
                <img src="images/icons/Foneapp Logo-03.png" className="imagesize" alt="FoneApp Community"/>
                </a>

                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto">
                    
                        <li className="nav-item">
                            <a className="nav-link click-scroll" href={isTandCPage || isPandPPage ? "/#section_AboutUs" : "#section_AboutUs"}>About Us</a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link click-scroll" href={isTandCPage || isPandPPage ? "/#section_M20" : "#section_M20"}>M2O Loyalty Program</a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link click-scroll" href={isTandCPage || isPandPPage ? "/#section_Partner" : "#section_Partner"}>Be Our Partner</a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link click-scroll" href={isTandCPage || isPandPPage ? "/#section_FonePlus" : "#section_FonePlus"}>FonePlus</a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link click-scroll" href={isTandCPage || isPandPPage ? "/#section_Team" : "#section_Team"}>Our Team</a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link click-scroll" href={isTandCPage || isPandPPage ? "/#section_ContactUs" : "#section_ContactUs"}>Contact Us</a>
                        </li>
                       

                        {/* <li className="nav-item">
                            <a className="nav-link1 click-scroll" href="#section_8"><img src="https://cdn.builder.io/api/v1/image/assets/TEMP/3e50ead2ffee7e942f0b49fd3b0a5a271b988199c97eea08459a3c5608e20e92?placeholderIfAbsent=true&apiKey=926938208ece40cbaafd9a1cbf947af6" alt="Search Icon" className="imagesize1"/></a>
                        </li> */}

                    </ul>
                </div>
            </div>
        </nav>

        <div className="site-header1">
        </div>

    </div>
  )
}

export default NavBar
